import { render } from "./indicator-edit-modal.vue?vue&type=template&id=50848528"
import script from "./indicator-edit-modal.vue?vue&type=script&lang=js"
export * from "./indicator-edit-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__